import React from 'react'
import {
  branch,
  compose,
  lifecycle,
  renderComponent,
  withState,
} from 'recompose'
import { connect } from 'react-redux'
import isNode from 'detect-node'
import { Redirect } from 'react-router-dom'
import { addOrder } from 'pages/order/modules/order'
import { loadVendor } from './modules/info'
import { loadMenu } from './modules/menu'
import WhiteLabelVendorView from './WhiteLabelVendorView'

export default compose(
  connect(
    (state, props) => ({
      ...state.vendor.info,
      order: state.order.orders[props.match.params.id],
    }),
    { addOrder, loadMenu, loadVendor },
  ),

  withState('isNotFound', 'setIsNotFound', false),

  lifecycle({
    bootstrap() {
      const { match, loadMenu, loadVendor, setIsNotFound } = this.props
      const venueId = match.params.id
      const servicetype = 'takeaway'

      return Promise.all([
        loadVendor(venueId),
        loadMenu(venueId, { servicetype }),
      ]).catch(error => {
        if (error.response.status === 404) setIsNotFound(true)
      })
    },

    componentDidMount() {
      if (!isNode) this.bootstrap()
    },
  }),

  branch(p => p.isNotFound, renderComponent(() => <Redirect to="/404" />)),
)(WhiteLabelVendorView)
